import { TourOrderWrapper } from "./styled"
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import TableComponent from "components/Table";
import { tourOrderSelector, tourTypeSelector, customerSelector, staffSelector } from 'redux/selector'
import { tourOrderActions } from 'redux/slice/tourOrder'
import { setPrice } from "utils";
import DateTimePicker from "components/DateTimePicker";
import Loading from "components/Loading";
import { tourTypeActions } from "redux/slice/tourTypeSlice";
import { customerActions } from "redux/slice/customerSlice";
import { staffActions } from "redux/slice/staffSlice";
import timeNow, { getTimeCustom } from 'helpers/timenow'
import ErrorMessage from "components/ErrorMessage";
import { get_day_of_time } from 'utils'
import Label from "components/Label";

const Bill = () => {
    document.title = 'Quản lý đặt tour'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const tourTypeState = useSelector(tourTypeSelector)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const tourOrderState = useSelector(tourOrderSelector)
    const staffState = useSelector(staffSelector)
    const customerState = useSelector(customerSelector)
    const dispatch = useDispatch()
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const [tourType, setTourType] = useState('all')
    const [customer, setCustomer] = useState('all')
    const [staff, setStaff] = useState('all')
    const dateAfter = new Date();
    dateAfter.setDate(dateAfter.getDate() - 7);
    const [startDate, setStartDate] = useState(getTimeCustom(dateAfter))
    const [endDate, setEndDate] = useState(timeNow())
    const [errorDate, setErrorDate] = useState("")

    useEffect(() => {
        dispatch(customerActions.getAllCustomer())
        dispatch(staffActions.getAllStaff())
    }, [dispatch])


    useEffect(() => {
        if (get_day_of_time(new Date(startDate), new Date(endDate)) < 0) {
            setErrorDate("Vui lòng chọn ngày bắt đầu nhỏ hơn hoặc bằng ngày kết thúc!")
        } else {
            setErrorDate("")
            dispatch(tourOrderActions.getStatistical({ tourType, startDate: startDate, endDate: endDate, currentPage, customer, staff }))
        }
    }, [currentPage, customer, dispatch, endDate, staff, startDate, tourType])


    useEffect(() => {
        dispatch(tourTypeActions.getTourTypeAll())
    }, [dispatch])

    const totalPrice = useMemo(() => {
        if (tourOrderState.statistical.length > 0) {
            let initialValue = 0
            const res = tourOrderState.statistical.reduce((total, item) => {
                return total + (item.price * item.amount_of_people - item.price * item.amount_of_people / 100 * item.discount)
            }, initialValue)
            return res
        } else {
            return 0
        }
    }, [tourOrderState.statistical])


    const handleChangeTourType = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/order?page=1`)
        }
        setTourType(e.target.value)
    }

    const handleChangeCustomer = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/order?page=1`)
        }
        setCustomer(e.target.value)
    }

    const handleChangeStaff = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/order?page=1`)
        }
        setStaff(e.target.value)
    }


    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/order?page=${pageNumber}`)
    }


    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            align: "center"
        },
        {
            title: 'Tour',
            dataIndex: 'name',
            key: 'name',
            align: "center"
        },
        {
            title: 'Khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            align: "center"
        },
        {
            title: 'Điện thoại',
            dataIndex: 'customer_phone',
            key: 'customer_phone',
            align: "center"
        },
        {
            title: 'Ngày khởi hành',
            dataIndex: 'departure_day',
            key: 'departure_day',
            align: "center",
        },
        {
            title: 'Kết thúc',
            dataIndex: 'tour_order_updated_at',
            key: 'tour_order_updated_at',
            align: "center",

        },
        {
            title: 'Số người',
            dataIndex: 'amount_of_people',
            key: 'amount_of_people',
            align: "center"
        },
        {
            title: 'Đơn giá / người',
            key: 'price',
            align: "center",
            render: ({ price }) => (
                <span>{setPrice(price)}</span>
            )
        },
        {
            title: 'Giảm giá',
            dataIndex: 'discount',
            key: 'discount',
            align: "center"
        },
        {
            title: 'Tổng tiền',
            align: "center",
            render: ({ price, amount_of_people, discount }) => (
                <span>{setPrice(price * amount_of_people - price * amount_of_people / 100 * discount)}</span>
            )
        },
        {
            title: 'Phụ trách',
            dataIndex: 'staff_name',
            key: 'staff_name',
            align: "center"
        }
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + tourOrderState.statistical.length)
        }
        else {
            setTotalItemInPage(tourOrderState.statistical.length)
        }
    }, [currentPage, tourOrderState.statistical.length])
    return (
        <TourOrderWrapper>
            <div className="admin_order_control py-0 px-15">
                <div>
                    <div className="admin_order_control py-0 px-15">
                        <DateTimePicker
                            dateInit={new Date(startDate)}
                            onChangeDate={(date) => setStartDate(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                        />
                        <span className="mx-5 text-black">Đến:</span>
                        <DateTimePicker
                            dateInit={new Date(endDate)}
                            onChangeDate={(date) => setEndDate(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                        />
                    </div>
                    {
                        errorDate !== "" &&
                        <ErrorMessage>{errorDate}</ErrorMessage>
                    }
                </div>
                <div className="admin_order_control_sort-add">
                    <div className="admin_order_control_sort-add">
                        <Label className="mr-10">Nhân viên</Label>
                        <select className="mr-15 px-10" value={staff} onChange={handleChangeStaff}>
                            <option value='all'>Toàn bộ</option>totalPrice
                            {
                                staffState.staffAllList.map((item, index) => (
                                    <option value={item.account_id} key={index}>{item.account_name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="admin_order_control_sort-add">
                        <Label className="mr-10">Khách hàng</Label>
                        <select className="mr-15 px-10" value={customer} onChange={handleChangeCustomer}>
                            <option value='all'>Toàn bộ</option>totalPrice
                            {
                                customerState.customerAllList.map((item, index) => (
                                    <option value={item.account_id} key={index}>{item.account_name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="admin_order_control_sort-add">
                        <Label className="mr-10">Loại tour</Label>
                        <select className="mr-15 px-10" value={tourType} onChange={handleChangeTourType}>
                            <option value='all'>Toàn bộ</option>totalPrice
                            {
                                tourTypeState.toutTypeListAll.map((item, index) => (
                                    <option value={item.id} key={index}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className="admin_order_table">

                {
                    tourOrderState.loading &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={tourOrderState?.statistical}
                />
            </div>
            {
                tourOrderState?.statistical?.length > 0 &&
                <div className="admin_order_pagination mt-15 px-15">
                    <div>
                        <span className="admin_order_pagination_total_item medium">
                            {totalItemInPage} / {tourOrderState.totalItem}
                        </span>
                        <span className="ml-20 text-black medium s-18">Tổng: <span className="text-red bold">{setPrice(totalPrice)}</span> đ</span>
                    </div>
                    {
                        tourOrderState.totalPage > 1 &&
                        <Pagination count={tourOrderState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
        </TourOrderWrapper>
    )
}

export default Bill